import { useEffect, useState } from 'react';
import './homepage.css';

const EventTimingSection = () => {
    const [timeLeft, setTimeLeft] = useState({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      });
    
      useEffect(() => {
        const makeTimer = () => {
          const endTime = new Date("7 December 2025 9:00:00 GMT+01:00").getTime();
          const now = new Date().getTime();
    
          const timeLeft = endTime - now;
    
          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
          setTimeLeft({
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds
          });
        };
    
        const timerInterval = setInterval(makeTimer, 1000);
    
        return () => clearInterval(timerInterval);
      }, []);
    
  return (
    <section className='timing-section page-width px-3 overflow-hidden my-2 my-md-5 py-3 py-md-5'>
        <div className="time-details row my-5 pb-0 pb-md-5">
          <div className="time-details_column1 col-md-6 col-sm-12 js-scroll slide-left mb-3">
            <h2 className="text-uppercase">A TECH CONFERENCE OF THIS SCALE HAPPENING LIVE IN THE <span>CITY OF ABUJA!</span></h2>
            <p>Dec 7th, 2024.</p>
          </div>
          <div className="time-details_column2 col-md-6 col-sm-12 js-scroll slide-right mb-3">
            <p>Happening live at a 2000 seater capacity space at, Light Place Event Center, Abidjan St Wuse 3, Abuja Nigeria.</p>
          </div>
        </div>

        <section id="timer" className="countdown-section js-scroll fade-in my-0 my-md-5">
            <div className="time" >
                <h2 id="days">{timeLeft.days}</h2>
                <p>Days</p>
            </div>
            <div className="time" >
                <h2 id="hours">{timeLeft.hours}</h2>
                <p>Hours</p>
            </div>
            <div className="time" >
                <h2 id="minutes">{timeLeft.minutes}</h2>
                <p>Minutes</p>
            </div>
            <div className="time" >
                <h2 id="seconds">{timeLeft.seconds}</h2>
                <p>Seconds</p>
            </div>
        </section>

    </section>
  )
}

export default EventTimingSection